import React, { useState } from 'react';
import Sticky from 'react-stickynode';
import { useSelector } from 'react-redux';
import { trim, some } from 'lodash';

import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { userPiDataSelector } from '../../redux/selectors/cartSelectors';
import { phobioSelector } from '../../redux/selectors/phoneSelectors';
import SessionTimer from '../SessionTimer/session-timer';
import extractArrayData from '../../utils/extractArrayData';
import { Contentful } from '../../types';
import {
  Container,
  DesktopWrapper,
  LogoContainer,
  MobileWrapper,
  NavLink,
  StyledImage,
} from '../sections/Header/styles';
import { HeaderInnerContainer } from './styles';

interface Props {
  headerData: Record<string, any>;
  preferredLocale?: string;
}

const SetupHeader = ({ headerData, preferredLocale }: Props) => {
  const userPiData = useSelector(userPiDataSelector);
  const phobioDetails = useSelector(phobioSelector);
  const breakpoints = useBreakpoint();

  const [isStuck, setIsStuck] = useState(false);

  const handleStickyChange = ({ status }) => setIsStuck(status === Sticky.STATUS_FIXED);

  const sessionTimerData = extractArrayData(
    headerData.headerBlades,
    Contentful.ContentfulId,
    '5bnK3Tw6PzWqAd6ZCR8EJ8',
  ).bladeSections;

  const timerBladeWait = extractArrayData(
    sessionTimerData,
    Contentful.ContentfulId,
    '66f6yspjNRbDUGLvah6sP9',
  ).value;
  const totalIdleTime = extractArrayData(
    sessionTimerData,
    Contentful.ContentfulId,
    '1qoojWoJqljUNlBrWErzfM',
  ).value;

  return (
    <Sticky
      enabled
      innerZ={999}
      enableTransforms={false}
      onStateChange={handleStickyChange}
    >
      {(some(userPiData, (item) => trim(item) !== '') || phobioDetails) && (
        <SessionTimer
          cms={sessionTimerData}
          timeout={totalIdleTime * 60 * 1000}
          promptBeforeIdle={timerBladeWait * 60 * 1000}
        />
      )}
      <Container className={isStuck ? 'is-stuck' : ''}>
        {/* MOBILE MENU */}

        {breakpoints.md && (
          <MobileWrapper>
            <LogoContainer locale={preferredLocale!}>
              <NavLink to={`/${preferredLocale}`} tabIndex="0">
                <StyledImage image={headerData.logoDam} />
              </NavLink>
            </LogoContainer>
          </MobileWrapper>
        )}

        {/* DESKTOP HEADER */}
        {breakpoints.desktop && (
          <DesktopWrapper>
            {/* LOGO */}
            <HeaderInnerContainer
              className="navigation"
              role="navigation"
              aria-label="navigation"
            >
              <LogoContainer
                locale={preferredLocale!}
                className={preferredLocale === 'en' ? '' : 'fr'}
              >
                <NavLink to={`/${preferredLocale}`}>
                  <StyledImage image={headerData.logoDam} />
                </NavLink>
              </LogoContainer>
            </HeaderInnerContainer>
          </DesktopWrapper>
        )}
      </Container>
    </Sticky>
  );
};

export default SetupHeader;
